import { registerRootComponent } from 'expo';
import App from './App';
import AsyncStorage from '@react-native-async-storage/async-storage';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Parse = require('parse');
import { PARSE_APP_ID, PARSE_JS_KEY, PARSE_SERVER_URL } from '@env';

// Initialize Parse
const initializeParse = () => {
  try {
    // Check if keys are loaded
    if (!PARSE_APP_ID || !PARSE_JS_KEY) {
      console.error('Parse keys not found. Check your .env file and babel config.');
      return false;
    }
    
    // Initialize Parse
    Parse.setAsyncStorage(AsyncStorage);
    
    Parse.initialize(
      PARSE_APP_ID,
      PARSE_JS_KEY
    );
    
    // Set server URL
    Parse.serverURL = PARSE_SERVER_URL;
    
    console.log('Parse initialized successfully in index.ts');
    return true;
  } catch (error) {
    console.error('Error initializing Parse:', error);
    return false;
  }
};

// Run initialization immediately
const initialized = initializeParse();
if (!initialized) {
  console.warn('Parse initialization failed, app may not work correctly');
}

// Register the root component
registerRootComponent(App);